import React, { useContext } from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import ScrollFadeWrapper, {
  ScrollFadeSkipEntranceContext,
} from '../ScrollFadeWrapper/ScrollFadeWrapper';
import LaunchPad from '../HomePage/LaunchPad/LaunchPadComponent';
import LaunchPadMobile from '../HomePage/LaunchPad/LaunchPadMobileComponent ';
import LaunchPadHeroDesktop from '../HomePage/LaunchPad/LaunchPadHeroDesktopComponent';
import LaunchPadHeroMobile from '../HomePage/LaunchPad/LaunchPadHeroMobileComponent';
import { StaticHeroHandoffContext } from '../../staticHero/staticHeroHandoff';
import { SUB_PAGE_HERO_DATA } from './subPageHeroData';

const SubPageHero = ({ pathName = '/', heroGateKey, onImageLoad = null }) => {
  const isMobile = useMobileContext();
  // When the static hero from index.html is already showing this hero, the
  // React hero replaces it in place instead of animating in again.
  const takingOverStaticHero = useContext(StaticHeroHandoffContext);
  const heroData = SUB_PAGE_HERO_DATA[pathName];

  let hero;
  if (heroData) {
    const heroProps = {
      title: heroData.title,
      subtitle: heroData.subtitle,
      ctaLabel: heroData.ctaLabel,
      ctaRoute: heroData.ctaRoute,
      imageSrc: heroData.imageSrc,
      imageAlt: heroData.imageAlt,
      features: heroData.features,
      footnote: heroData.footnote,
      onImageLoad,
    };
    hero = (
      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <LaunchPadHeroDesktop
            key={heroGateKey}
            {...heroProps}
            footnoteAlign="left"
          />
        ) : (
          <LaunchPadHeroMobile
            key={heroGateKey}
            {...heroProps}
            footnoteAlign="center"
          />
        )}
      </ScrollFadeWrapper>
    );
  } else {
    hero = isMobile.isDesktop ? (
      <LaunchPad
        key={heroGateKey}
        pathName={pathName}
        onImageLoad={onImageLoad}
      />
    ) : (
      <LaunchPadMobile
        key={heroGateKey}
        pathName={pathName}
        onImageLoad={onImageLoad}
      />
    );
  }

  return (
    <ScrollFadeSkipEntranceContext.Provider value={takingOverStaticHero}>
      {hero}
    </ScrollFadeSkipEntranceContext.Provider>
  );
};

export default SubPageHero;
